import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';

import {
  FDK_ILLUSTRATION_DEFAULT_WIDTHS,
  FdkIllustrationName,
} from './illustration.types';

@Component({
  selector: 'fdk-illustration',
  templateUrl: './illustration.component.html',
  styleUrl: './illustration.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    '[style.width]': 'resolvedWidth',
  },
})
export class FdkIllustrationComponent {
  @Input({ required: true }) name!: FdkIllustrationName;
  @Input('aria-label') ariaLabel: string | null = null;

  get normalizedAriaLabel(): string | null {
    const label = this.ariaLabel?.trim();
    return label ? label : null;
  }

  get ariaHidden(): 'true' | null {
    return this.normalizedAriaLabel ? null : 'true';
  }

  get role(): 'img' | null {
    return this.normalizedAriaLabel ? 'img' : null;
  }

  get resolvedWidth(): string {
    return `${FDK_ILLUSTRATION_DEFAULT_WIDTHS[this.name] ?? 0}px`;
  }
}
